import gql from 'graphql-tag';

export const removeCompanyRole = gql`
  mutation removeCompanyRole(
    $userIds: [UUID!]!
    $roleTemplateIds: [UUID!]!
    $channelId: UUID!
  ) {
    removeCompanyRole(
      userIds: $userIds
      roleTemplateIds: $roleTemplateIds
      channelId: $channelId
    ) {
      channelId
      success
      errorCode
      message
    }
  }
`;

